import {
  Timeline,
  TimelineItem,
  TimelineConnector,
  TimelineHeader,
  TimelineIcon,
  TimelineBody,
  Typography,
  Avatar,
} from "@material-tailwind/react";
import { clg, hs, secondary } from "../../assets";

const Education = () => {
  const eduList = [
    {
      level: "Bechelor of Technology [Sept, 2020 - July, 2024]",
      name: "College of Engineering and Management, Kolaghat",
      icon: clg,
      dept: "Computer Science & Engineering ",
      time: "Grade(CGPA) : 8.95",
    },
    {
      level: "Higher Secondery [Aug, 2019 - july, 2020]",
      name: "Haldia Government Sponsored Vivekananda Vidyabhawan",
      icon: hs,
      dept: "Pure Science ",
      time: "Grade : 80.06 %",
    },
    {
      level: "Secondary [ 2018]",
      name: "Rampur Vivekananda Mission Vidyamandir",
      icon: secondary,
      dept: "General",
      time: "Grade : 84.86 %",
    },
  ];

  return (
    <div className="max-w-[32rem] flex justify-center items-center mx-auto">
      <Timeline>
        {eduList.map((education) => (
          <TimelineItem key={education.level}>
            <TimelineConnector />
            <TimelineHeader>
              <TimelineIcon className="p-0 animate-bounce">
                <Avatar size="md" src={education.icon} alt={education.level} />
              </TimelineIcon>
              <Typography variant="h5" color="blue-gray" >
                {education.name}
              </Typography>
            </TimelineHeader>
            <TimelineBody className="pb-12">
              <Typography
                color="gray"
                className="font-semibold text-sm text-gray-700"
              >
                {education.level}
                <br />
                {education.dept} <br /> {education.time}
              </Typography>
            </TimelineBody>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  );
};

export default Education;
